/**
 * @generated SignedSource<<721dca5b05982d6fc435af7d2a1dd714>>
 * @relayHash 93b3893a8e9a1daa7b144c57b1a4a9d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2856644f2efd708a0c94f2c0495a994e7de8bc5389ada3a88bbe8d568f1b0876

import type { ConcreteRequest } from 'relay-runtime';
export type realtimePublishChannelMutation$variables = {
  context?: string | null | undefined;
  installationId: string;
  isGlobal?: boolean | null | undefined;
  name: string;
  payload: string;
  token?: string | null | undefined;
};
export type realtimePublishChannelMutation$data = {
  readonly ecosystem: {
    readonly publishRealtimeChannel: {
      readonly eventId: string | null | undefined;
      readonly eventTimestamp: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type realtimePublishChannelMutation = {
  response: realtimePublishChannelMutation$data;
  variables: realtimePublishChannelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "installationId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGlobal"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "payload"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v6 = [
  {
    "concreteType": "EcosystemMutation",
    "kind": "LinkedField",
    "name": "ecosystem",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "context",
            "variableName": "context"
          },
          {
            "kind": "Variable",
            "name": "installationId",
            "variableName": "installationId"
          },
          {
            "kind": "Variable",
            "name": "isGlobal",
            "variableName": "isGlobal"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "payload",
            "variableName": "payload"
          },
          {
            "kind": "Variable",
            "name": "token",
            "variableName": "token"
          }
        ],
        "concreteType": "EcosystemRealtimePublishBody",
        "kind": "LinkedField",
        "name": "publishRealtimeChannel",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "eventId"
          },
          {
            "kind": "ScalarField",
            "name": "eventTimestamp"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "realtimePublishChannelMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "realtimePublishChannelMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "id": "2856644f2efd708a0c94f2c0495a994e7de8bc5389ada3a88bbe8d568f1b0876",
    "metadata": {},
    "name": "realtimePublishChannelMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "5ea0f10b611a7938d84804613e71e265";

export default node;
